var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var widgetMetricCellValue = 'font-semibold text-gray-900 tabular-nums whitespace-nowrap shrink-0';
/** Tailwind passed into `BadgeDiff` in metric cells. */
export var widgetMetricCellBadgeDiff = 'bg-transparent shrink-0';
/** `grid-cols`: value | period | team (7rem slots; third may be empty). */
export var widgetMetricCellThreeColGridFull = 'grid w-full min-w-0 grid-cols-[minmax(0,1fr)_7rem_7rem] items-center gap-x-3 px-2';
/** Keeps row height when a diff badge is hidden. */
export var widgetMetricCellInvisibleBadgeSlot = 'invisible pointer-events-none flex min-h-8 w-full min-w-0 shrink-0 items-center justify-start';
/** `WidgetMetricComparisonCell` with `compactAlign="start"` (e.g. under left-aligned headers). */
export var widgetMetricCellCompactMetricWrapStart = 'flex w-full min-w-0 justify-start px-2';
export var widgetMetricCellThreeColDiff = 'flex w-full min-w-0 flex-nowrap items-center justify-start justify-self-stretch';
/** Figure slot: `min-w-[5ch]` aligns digits without changing `widgetMetricCellValue`. */
export var widgetMetricCellFigureValue = 'inline-block min-w-[5ch] shrink-0 text-end font-semibold text-gray-900 tabular-nums whitespace-nowrap';
export var widgetMetricCellCountSpan = 'inline-block text-right';
export var widgetMetricCellDurationText = 'shrink-0 font-normal tabular-nums text-gray-900 whitespace-nowrap';
export var widgetMetricTableColMetricValueStyle = {
    width: '1%',
    minWidth: '2.5rem'
};
export var widgetMetricTableColMetricPeriodDiffLeanStyle = {
    width: '1%',
    minWidth: '5.25rem'
};
/**
 * Work patterns (no team column): wider period `<col>` so extra table width does not
 * land on the value `<col>` and separate the count from the badge.
 */
export var widgetMetricTableColMetricPeriodDiffWorkPatternsStyle = {
    width: '13%',
    minWidth: '5.25rem'
};
/** `<colgroup>`: value | period diff | third col for team-avg badge. */
export var initiativeMetricTrioWithTeamSlackThird = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffLeanStyle,
    {}
];
var colgroupNoSparklineTwoPairs = [
    { width: '28%' },
    widgetMetricTableColMetricValueStyle,
    { width: '17%', minWidth: '5.25rem' },
    widgetMetricTableColMetricValueStyle,
    { width: '17%', minWidth: '5.25rem' }
];
/** Colgroup for Invocations / Meet meetings types / Power AI (with or without team diff). */
export function widgetMetricTableColgroupInvocationsByApp(includeTeamDiffColumn) {
    if (includeTeamDiffColumn) {
        return __spreadArray(__spreadArray([
            { width: '28%' }
        ], initiativeMetricTrioWithTeamSlackThird, true), initiativeMetricTrioWithTeamSlackThird, true);
    }
    return __spreadArray([], colgroupNoSparklineTwoPairs, true);
}
export var widgetMetricTableDurationSlashClass = 'font-normal text-gray-500';
export var widgetMetricTablePairHeaderThClass = 'min-w-0 !text-left whitespace-nowrap align-bottom leading-tight tracking-normal !px-2';
/** Adds `!pl-3` so header text lines up with `<td>` body padding (`px-3`). */
export var widgetMetricTablePairHeaderThAlignBodyTdClass = [
    widgetMetricTablePairHeaderThClass,
    '!pl-3'
].join(' ');
/** Value `<td>`: strip right padding so the count sits next to the diff column. */
export var widgetMetricTableValueTdClass = 'min-w-0 whitespace-nowrap !text-left align-top tabular-nums !pr-0';
export var widgetMetricTableDiffTdClass = 'min-w-0 whitespace-nowrap !text-left align-top !pl-0';
/** Period diff `<td>` before team: no right padding so the two badges stay evenly spaced. */
export var widgetMetricTablePeriodDiffBeforeTeamTdClass = [
    widgetMetricTableDiffTdClass,
    '!pr-0'
].join(' ');
export var widgetMetricTablePrimaryLabelTdClass = 'min-w-0 align-top !text-left';
export var widgetMetricTableChartTdClass = 'min-w-0 align-top !text-left';
export var widgetMetricTableValueCellInnerClass = 'flex w-full min-w-0 justify-start pl-0 pr-0';
/**
 * `inline-flex` + `w-fit` so the cell’s content box hugs the figure (avoids a full-width
 * flex strip inside a narrow `<td>`).
 */
export var widgetMetricTableValueCellInnerFitClass = 'inline-flex w-fit max-w-full min-w-0 justify-start pl-0 pr-0';
export var widgetMetricTableFigureValueSpanClass = [
    widgetMetricCellCountSpan,
    '!min-w-0',
    '!text-start',
    widgetMetricCellFigureValue
].join(' ');
/** Like `widgetMetricTableFigureValueSpanClass` but drops `min-w-[5ch]` for short counts. */
export var widgetMetricTableFigureValueSpanHugClass = 'inline-block !min-w-0 !text-start font-semibold text-gray-900 tabular-nums whitespace-nowrap items-center';
